export function inMetamaskBrowser(): boolean {
  const ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  // Treat only the MetaMask mobile in-app browser as "MetaMask browser"
  const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);
  const mentionsMetaMask = /MetaMask|MetaMaskMobile/i.test(ua);
  return isMobile && mentionsMetaMask;
}

export function getMetamaskUniversalLink(currentUrl?: string): string {
  const current = currentUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
  const clean = current.replace(/^https?:\/\//, '');
  return `https://metamask.app.link/dapp/${clean}`;
}

export function openInMetamask(currentUrl?: string): void {
  const mmUniversal = getMetamaskUniversalLink(currentUrl);
  if (typeof window !== 'undefined') {
    window.location.href = mmUniversal;
  }
}

export function isMetaMaskActiveWallet(wallet: any): boolean {
  // Best effort detection of an active MetaMask wallet from thirdweb wallet object
  try {
    // Direct wallet info
    const info = wallet?.getWalletInfo?.();
    const id = wallet?.id || wallet?.walletId || info?.id;
    const name = info?.name || wallet?.name;
    if (typeof id === 'string' && id.toLowerCase().includes('metamask')) {
      return true;
    }
    if (typeof name === 'string' && /metamask/i.test(name)) {
      return true;
    }

    // Personal wallet (for smart/account abstraction wrappers)
    const personal = wallet?.getPersonalWallet?.();
    const pInfo = personal?.getWalletInfo?.();
    const pId = personal?.id || personal?.walletId || pInfo?.id;
    const pName = pInfo?.name || personal?.name;
    if (typeof pId === 'string' && pId.toLowerCase().includes('metamask')) {
      return true;
    }
    if (typeof pName === 'string' && /metamask/i.test(pName)) {
      return true;
    }

    // Provider flags (desktop extension or injected)
    const provider = (wallet as any)?.getProvider?.() || (wallet as any)?.provider;
    if (provider?.isMetaMask) {
      return true;
    }

    // WalletConnect peer metadata (when connected via WC to MetaMask app)
    const connector = provider?.connector || (wallet as any)?.connector;
    const peerName = connector?.peerMetadata?.name || connector?.peer?.metadata?.name;
    if (typeof peerName === 'string' && /metamask/i.test(peerName)) {
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}


